import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiX, FiChevronLeft, FiChevronRight, FiImage, FiCheck } from "react-icons/fi";
import { useInView } from "../components/useInView";
import "./Portfolio.css";

/* ════════════════════════════════════════════════════════════
   HERO BACKGROUND — local asset
   ════════════════════════════════════════════════════════════ */
import heroBg from "../assets/images/portfolio/ppt_media_image18.jpeg";

/* ════════════════════════════════════════════════════════════
   TAB PANEL IMAGES — reuse about images
   ════════════════════════════════════════════════════════════ */
import tabImg1 from "../assets/images/about/ppt_media_image11.jpg";
import tabImg2 from "../assets/images/about/ppt_media_image12.jpg";
import tabImg3 from "../assets/images/about/ppt_media_image13.jpg";

/* ════════════════════════════════════════════════════════════
   PARTNER LOGOS
   ════════════════════════════════════════════════════════════ */
import partner_1  from "../assets/images/partners/partner_01.jpg";
import partner_2  from "../assets/images/partners/partner_02.jpg";
import partner_3  from "../assets/images/partners/partner_03.jpg";
import partner_4  from "../assets/images/partners/partner_04.jpg";
import partner_5  from "../assets/images/partners/partner_05.jpg";
import partner_6  from "../assets/images/partners/partner_06.jpg";
import partner_8  from "../assets/images/partners/partner_08.jpg";
import partner_9  from "../assets/images/partners/partner_09.jpg";
import partner_10 from "../assets/images/partners/partner_10.jpg";
import partner_11 from "../assets/images/partners/partner_11.jpg";
import partner_12 from "../assets/images/partners/partner_12.jpg";
import partner_13 from "../assets/images/partners/partner_13.jpg";
import partner_14 from "../assets/images/partners/partner_14.jpg";
import partner_15 from "../assets/images/partners/partner_15.png";
import partner_16 from "../assets/images/partners/partner_16.jpg";
import partner_17 from "../assets/images/partners/partner_17.jpg";

const partnerLogos = [
  partner_1,  partner_2,  partner_3,  partner_4,  partner_5,
  partner_6, partner_8,  partner_9,  partner_10,
  partner_11, partner_12, partner_13, partner_14, partner_15,
  partner_16, partner_17,
];

/* ════════════════════════════════════════════════════════════
   STATIC IMAGE IMPORTS
   ════════════════════════════════════════════════════════════ */
import g4_01 from "../assets/images/portfolio/g4-mining_01.jpg";
import g4_02 from "../assets/images/portfolio/g4-mining_02.jpg";
import g4_03 from "../assets/images/portfolio/g4-mining_03.jpg";
import g4_04 from "../assets/images/portfolio/g4-mining_04.jpg";

import ferrobank_01 from "../assets/images/portfolio/ferrobank_01.jpg";
import ferrobank_02 from "../assets/images/portfolio/ferrobank_02.jpg";
import ferrobank_03 from "../assets/images/portfolio/ferrobank_03.jpg";

import dannhauser_01 from "../assets/images/portfolio/dannhauser_01.jpg";
import dannhauser_02 from "../assets/images/portfolio/dannhauser_02.jpg";
import dannhauser_03 from "../assets/images/portfolio/dannhauser_03.jpg";

import ferrobank_04 from "../assets/images/portfolio/ferrobank_04.jpg";
import ferrobank_05 from "../assets/images/portfolio/ferrobank_05.jpg";
import ferrobank_06 from "../assets/images/portfolio/ferrobank_06.jpg";

import kuruman_01 from "../assets/images/portfolio/kuruman_01.jpg";
import kuruman_02 from "../assets/images/portfolio/kuruman_02.jpg";
import kuruman_03 from "../assets/images/portfolio/kuruman_03.jpg";
import kuruman_04 from "../assets/images/portfolio/kuruman_04.jpg";
import kuruman_05 from "../assets/images/portfolio/kuruman_05.jpg";
import kuruman_06 from "../assets/images/portfolio/kuruman_06.jpg";

import aerosud_01 from "../assets/images/portfolio/aerosud_01.jpg";
import aerosud_02 from "../assets/images/portfolio/aerosud_02.jpg";
import aerosud_03 from "../assets/images/portfolio/aerosud_03.jpg";
import aerosud_04 from "../assets/images/portfolio/aerosud_04.jpg";
import aerosud_05 from "../assets/images/portfolio/aerosud_05.jpg";

import columns_01 from "../assets/images/portfolio/columns_01.jpg";
import columns_02 from "../assets/images/portfolio/columns_02.jpg";
import columns_03 from "../assets/images/portfolio/columns_03.jpg";
import columns_04 from "../assets/images/portfolio/columns_04.jpg";
import columns_05 from "../assets/images/portfolio/columns_05.jpg";

import degrit_01 from "../assets/images/portfolio/ferrobank-de-grit-01.jpg";
import degrit_02 from "../assets/images/portfolio/ferrobank-de-grit-02.jpg";
import degrit_03 from "../assets/images/portfolio/ferrobank-de-grit-03.jpg";

import pst_01 from "../assets/images/portfolio/ferrobank-pst-tank_01.jpg";
import pst_02 from "../assets/images/portfolio/ferrobank-pst-tank_02.jpg";
import pst_03 from "../assets/images/portfolio/ferrobank-pst-tank_03.jpg";
import pst_04 from "../assets/images/portfolio/ferrobank-pst-tank_04.jpg";

import steelpoort_01 from "../assets/images/portfolio/steelpoort_01.jpg";
import steelpoort_02 from "../assets/images/portfolio/steelpoort_02.jpg";
import steelpoort_03 from "../assets/images/portfolio/steelpoort_03.jpg";
import steelpoort_04 from "../assets/images/portfolio/steelpoort_04.jpg";
import steelpoort_05 from "../assets/images/portfolio/steelpoort_05.jpg";
import steelpoort_06 from "../assets/images/portfolio/steelpoort_06.jpg";

/* ════════════════════════════════════════════════════════════
   TAB DATA
   ════════════════════════════════════════════════════════════ */
const infoTabs = [
  {
    label: "Customer Training",
    img: tabImg1,
    title: "Customer Demonstrations & Training Facility",
    bullets: [
      "Bakwena Kit has a demonstration facility at our Head Office where we offer hands-on practical training.",
      "We provide our customers with a more detailed understanding of the benefits our equipment can provide.",
      "Hands-on practical training in the safe and efficient use of our products is undertaken either at our demonstration facility or on our customer's site — ensuring all the knowledge needed to work safely with our equipment on site, on time and in full.",
    ],
  },
  {
    label: "Equipment Availability",
    img: tabImg2,
    title: "Equipment Availability",
    bullets: [
      "With dedicated formwork storage yards throughout South Africa, Bakwena Kit can respond quickly and easily to our customer's requirements.",
      "With access to our extensive regional network, our customers benefit from availability, flexible delivery and improved equipment storage.",
      "A high-quality fleet, delivered when it's needed — on time and in full.",
    ],
  },
  {
    label: "Airodek System",
    img: tabImg3,
    title: "Airodek System",
    bullets: [
      "The Airodek system of lightweight aluminium panels and adjustable props means 30% less weight and 40% fewer parts than conventional steel props and timber.",
      "25% less weight than other systems using primary beams and panels.",
      "All of which saves time, labour and cost — delivering a faster, safer, and more economical solution on every project.",
    ],
  },
];

/* ════════════════════════════════════════════════════════════
   PROJECT DATA
   ════════════════════════════════════════════════════════════ */
const projects = [
  { id: 1,  title: "G4 Mining & Civils",       subtitle: "Matla Coal Mine",          category: "Mining",         images: [g4_01, g4_02, g4_03, g4_04] },
  { id: 2,  title: "Reservoir Specialized",     subtitle: "Water Structures",         category: "Water",          images: [ferrobank_01, ferrobank_02, ferrobank_03] },
  { id: 3,  title: "Dannhauser Reservoir",      subtitle: "3.5 ML Capacity",          category: "Water",          images: [dannhauser_01, dannhauser_02, dannhauser_03] },
  { id: 4,  title: "Ferrobank Waste Water",     subtitle: "Treatment Plant",          category: "Water",          images: [ferrobank_04, ferrobank_05, ferrobank_06] },
  { id: 5,  title: "Kuruman Circulation Tanks", subtitle: "Civils Infrastructure",    category: "Civils",         images: [kuruman_01, kuruman_02, kuruman_03, kuruman_04, kuruman_05, kuruman_06] },
  { id: 6,  title: "Aerosud Space",             subtitle: "Industrial Construction",  category: "Industrial",     images: [aerosud_01, aerosud_02, aerosud_03, aerosud_04, aerosud_05] },
  { id: 7,  title: "Ring Beams and Columns",    subtitle: "Structural Works",         category: "Structural",     images: [columns_01, columns_02, columns_03, columns_04, columns_05] },
  { id: 8,  title: "Ferrobank De-Grit",         subtitle: "Water Treatment",          category: "Water",          images: [degrit_01, degrit_02, degrit_03] },
  { id: 9,  title: "Ferrobank PST Tank",        subtitle: "Water Treatment",          category: "Water",          images: [pst_01, pst_02, pst_03, pst_04] },
  { id: 10, title: "Steelpoort Bridge",         subtitle: "R555 Road Infrastructure", category: "Infrastructure", images: [steelpoort_01, steelpoort_02, steelpoort_03, steelpoort_04, steelpoort_05, steelpoort_06] },
];

const ALL = "All";
const categories = [ALL, ...Array.from(new Set(projects.map((p) => p.category)))];

/* ════════════════════════════════════════════════════════════
   ANIMATED COUNTER
   ════════════════════════════════════════════════════════════ */
function Counter({ to, suffix = "", delay = 0 }) {
  const [ref, inView] = useInView();
  const el = useRef(null);
  useEffect(() => {
    if (!inView) return;
    let start = null;
    const run = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / 1800, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      if (el.current) el.current.textContent = Math.floor(eased * to);
      if (p < 1) requestAnimationFrame(run);
    };
    setTimeout(() => requestAnimationFrame(run), delay);
  }, [inView, to, delay]);
  return (
    <span ref={ref}>
      <span ref={el}>0</span>{suffix}
    </span>
  );
}

/* ════════════════════════════════════════════════════════════
   LIGHTBOX
   ════════════════════════════════════════════════════════════ */
function Lightbox({ project, onClose }) {
  const [idx, setIdx] = useState(0);
  const [switching, setSwitching] = useState(false);

  const navigate = useCallback((dir) => {
    const next = idx + dir;
    if (next < 0 || next >= project.images.length) return;
    setSwitching(true);
    setTimeout(() => { setIdx(next); setSwitching(false); }, 200);
  }, [idx, project.images.length]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape")     onClose();
      if (e.key === "ArrowLeft")  navigate(-1);
      if (e.key === "ArrowRight") navigate(1);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [navigate, onClose]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  return (
    <div className="pf-lightbox" role="dialog" aria-modal="true">
      <div className="pf-lightbox__backdrop" onClick={onClose} />
      <div className="pf-lightbox__panel">
        <div className="pf-lightbox__header">
          <div className="pf-lightbox__title-wrap">
            <span className="pf-lightbox__title">{project.title}</span>
            <span className="pf-lightbox__counter">{idx + 1} / {project.images.length}&nbsp;·&nbsp;{project.subtitle}</span>
          </div>
          <button className="pf-lightbox__close" onClick={onClose} aria-label="Close"><FiX size={18} /></button>
        </div>
        <div className="pf-lightbox__stage">
          <img
            key={idx}
            src={project.images[idx]}
            alt={`${project.title} — image ${idx + 1}`}
            className={`pf-lightbox__img${switching ? " switching" : ""}`}
            draggable="false"
            onDragStart={(e) => e.preventDefault()}
          />
          {project.images.length > 1 && (
            <>
              <button className="pf-lightbox__nav pf-lightbox__nav--prev" onClick={() => navigate(-1)} disabled={idx === 0} aria-label="Previous image"><FiChevronLeft size={22} /></button>
              <button className="pf-lightbox__nav pf-lightbox__nav--next" onClick={() => navigate(1)} disabled={idx === project.images.length - 1} aria-label="Next image"><FiChevronRight size={22} /></button>
            </>
          )}
        </div>
        {project.images.length > 1 && (
          <div className="pf-lightbox__thumbs">
            {project.images.map((src, i) => (
              <div
                key={i}
                className={`pf-lightbox__thumb${i === idx ? " active" : ""}`}
                onClick={() => { setSwitching(true); setTimeout(() => { setIdx(i); setSwitching(false); }, 200); }}
              >
                <img src={src} alt={`Thumbnail ${i + 1}`} draggable="false" onDragStart={(e) => e.preventDefault()} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PROJECT CARD
   ════════════════════════════════════════════════════════════ */
function ProjectCard({ project, delay, onOpen }) {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`pf-card fade-in${inView ? " visible" : ""}`}
      style={{ transitionDelay: `${delay}s` }}
      onClick={() => onOpen(project)}
      onContextMenu={(e) => e.preventDefault()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onOpen(project)}
      aria-label={`View gallery for ${project.title}`}
    >
      <div className="pf-card__photo">
        <img src={project.images[0]} alt={project.title} loading="lazy" draggable="false" onDragStart={(e) => e.preventDefault()} />
        <div className="pf-card__overlay" />
        <div className="pf-card__count-badge"><FiImage size={10} />&nbsp;{project.images.length} PHOTOS</div>
        <div className="pf-card__view-btn" aria-hidden="true">
          <div className="pf-card__view-btn-inner"><FiImage size={13} />&nbsp; VIEW GALLERY</div>
        </div>
        <div className="pf-card__cat-bar">
          <span className="pf-card__cat">{project.category}</span>
        </div>
      </div>
      <div className="pf-card__body">
        <h3 className="pf-card__title">{project.title}</h3>
        <p className="pf-card__sub">{project.subtitle}</p>
        <button className="pf-card__link">
          View Gallery
          <span className="pf-card__arrow"><FiArrowRight size={13} /></span>
        </button>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE
   ════════════════════════════════════════════════════════════ */
export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState(ALL);
  const [lightboxProject, setLightboxProject] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const [heroRef, heroInView] = useInView();
  const [gridRef, gridInView] = useInView();
  const [statRef, statInView] = useInView();
  const [processRef, processInView] = useInView();

  const filtered =
    activeFilter === ALL ? projects : projects.filter((p) => p.category === activeFilter);

  useEffect(() => {
    const handler = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handler);
    return () => document.removeEventListener("contextmenu", handler);
  }, []);

  const tab = infoTabs[activeTab];

  /* Process steps data */
  const steps = [
    { n: "01", title: "Initial Consultation",        desc: "We start by understanding your vision, goals, and requirements — laying the groundwork for a successful project." },
    { n: "02", title: "Strategic Planning & Design", desc: "Our team creates detailed plans, timelines, and cost estimates — ensuring alignment before a single brick is laid." },
    { n: "03", title: "Construction & Execution",    desc: "With skilled teams and strict supervision, we bring the design to life on time, on budget, to the highest standards." },
    { n: "04", title: "Final Handover & Support",    desc: "We complete inspections, walk you through results, and remain available for any post-build support you need." },
  ];

  return (
    <main className="pf">

      {/* ══════ 1. HERO ══════ */}
      <section className="pf-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="pf-hero__overlay" />
        <div className="container pf-hero__body" ref={heroRef}>
          <div className={`pf-hero__label fade-in${heroInView ? " visible" : ""}`}>OUR PORTFOLIO</div>
          <h1
            className={`pf-hero__title fade-in${heroInView ? " visible" : ""}`}
            style={{ transitionDelay: "0.1s" }}
          >
            BUILT WITH PRECISION
          </h1>
        </div>
        <div className="pf-hero__crumb">
          <Link to="/">Home</Link>
          <FiArrowRight size={13} />
          <span>Portfolio</span>
        </div>

        {/* ── Tab box anchored to bottom third of hero ── */}
        <div className="pf-info-box__anchor">
          <div className="container pf-info-box__wrapper">
            <div className={`pf-info-box fade-in${heroInView ? " visible" : ""}`} style={{ transitionDelay: "0.2s" }}>
              <div className="pf-info-box__tabs">
                {infoTabs.map((t, i) => (
                  <button
                    key={i}
                    className={`pf-info-box__tab${activeTab === i ? " active" : ""}`}
                    onClick={() => setActiveTab(i)}
                    type="button"
                  >
                    {t.label}
                  </button>
                ))}
              </div>
              <div className="pf-info-box__body">
                <div className="pf-info-box__img-wrap">
                  <img
                    src={tab.img}
                    alt={tab.title}
                    loading="lazy"
                    draggable="false"
                    onDragStart={e => e.preventDefault()}
                  />
                </div>
                <div className="pf-info-box__content">
                  <h3 className="pf-info-box__title">{tab.title}</h3>
                  <ul className="pf-info-box__list">
                    {tab.bullets.map((b, bi) => (
                      <li key={bi}>
                        <span className="pf-info-box__check" aria-hidden="true">
                          <FiCheck size={11} />
                        </span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════ 2 + 3. PORTFOLIO GRID — top padding absorbs tab box overlap ══════ */}
      <section className="pf-grid pf-grid--tab-offset" ref={gridRef}>
        <div className="container">
          <div className={`pf-grid__head fade-in${gridInView ? " visible" : ""}`}>
            <div className="pf-grid__tag">OUR PORTFOLIO</div>
            <h2 className="pf-grid__h2">Projects That Define Our Excellence</h2>
            <p className="pf-grid__sub">
              A showcase of our completed works — from mining civils and water
              infrastructure to industrial and structural construction.
            </p>
          </div>

          <div className="pf-filter">
            <span className="pf-filter__label">Filter By:</span>
            {categories.map((cat) => (
              <button
                key={cat}
                className={`pf-filter__btn${activeFilter === cat ? " active" : ""}`}
                onClick={() => setActiveFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="pf-projects">
            {filtered.map((project, i) => (
              <ProjectCard
                key={project.id}
                project={project}
                delay={Math.min(i * 0.07, 0.35)}
                onOpen={setLightboxProject}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ══════ 4. HAZARD STRIPE ══════ */}
      <div className="pf-stripe" aria-hidden="true" />

      {/* ══════ 6. HOW WE WORK (moved from Home) ══════ */}
      <section className="pf-process" ref={processRef}>
        <div className="pf-process__bg" />
        <div className="container">
          <div className={`pf-process__header fade-in${processInView ? " visible" : ""}`}>
            <div>
              <p className="pf-process__label">How We Work</p>
              <h2 className="pf-process__title">Our Step-by-Step<br /><span>Build Approach</span></h2>
            </div>
            <div className="pf-process__cta-box">
              <p>Big or small, every build starts here. Let's connect and get your project moving.</p>
              <Link to="/contact" className="btn-primary">Let's Connect <FiArrowRight /></Link>
            </div>
          </div>
          <div className="pf-process__steps">
            {steps.map((step, i) => (
              <div
                key={i}
                className={`pf-process-step fade-in${processInView ? " visible" : ""}`}
                style={{ transitionDelay: `${i * 0.12}s` }}
              >
                <div className="pf-process-step__num">{step.n}</div>
                {i < steps.length - 1 && <div className="pf-process-step__connector" />}
                <div className="pf-process-step__body">
                  <h3 className="pf-process-step__title">{step.title}</h3>
                  <p className="pf-process-step__desc">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════ 7. PARTNER LOGOS MARQUEE ══════ */}
      <section className="pf-partners">
        <div className="pf-partners__label-bar">
          <div className="container">
            <span className="pf-partners__heading">PROJECT REFERENCES &amp; CLIENTS</span>
          </div>
        </div>
        <div className="pf-partners__marquee">
          <div className="pf-partners__track">
            {[...partnerLogos, ...partnerLogos].map((src, i) => (
              <div key={i} className="pf-partners__logo">
                <img
                  src={src}
                  alt={`Partner ${(i % partnerLogos.length) + 1}`}
                  loading="lazy"
                  draggable="false"
                  onDragStart={(e) => e.preventDefault()}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════ LIGHTBOX ══════ */}
      {lightboxProject && (
        <Lightbox project={lightboxProject} onClose={() => setLightboxProject(null)} />
      )}

    </main>
  );
}